import { useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider';
import { Box, Button, Grid2 } from '@mui/material';
import useAuthStore from '../../store/useAuthStore';
import MarketingTable from '../commonfile/MarketingTable';
import PayoutTable from '../commonfile/PayoutTable';
import { useFacilityList } from '../../assets/api/useAdminApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import UtItem from '../../shared/utils/UtList';
import { Grid_Gap } from '../../shared/constants';
// import api from '../../assets/api/useStudentPostApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import TermAndConditionTable from './TermAndConditionTable';
import api from '../../assets/nodeApi/axiosInstance';

const ApartmentTCList = () => {
   
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const { user, token } = useAuthStore();

    const [selectedFacility, setSelectedFacility] = useState([])
    const { data: facilityList, isLoading } = useFacilityList()
  
    const facilityOption = facilityList?.map((item) => ({
        id: item?.id,
        value: item?.name,
        label: item?.name
    })) || [];
   
    const validationSchema = Yup.object().shape({
    });
  
    const initialValues = {
        facility_id: ""
    };
  
    const handleRemove = (id) => {
        setSelectedFacility(prev => prev.filter(apartment => apartment.id !== id));
    };
    
    const mutation = useMutation({
        mutationFn: (formData) => api.post("apartment-facilities", formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ),
    });
  
    const facilities = facilityOption.map(option => {
        const isSelected = selectedFacility.some(facility => facility.id === option.id);
        return {
            facility_id: option.id,
            is_available: isSelected ? "yes" : "no",
            status: isSelected ? "active" : "inactive"
        };
    });
   
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        if (selectedFacility.length === 0) {
            showToaster('At least one facility must be selected', 'Warning', 'warning');
            setSubmitting(false);
            return;
        }

        const data = {
            apartment_id: user?.apartment_id,
            facilities
        };
        mutation.mutate(data, {
            onSuccess: (response) => {
                showToaster('Success', response?.data?.message, 'success')
                queryClient.invalidateQueries({ queryKey: ['apartment-facilities'] });
                resetForm();
                setSelectedFacility([])
            },
            onError: (error) => {
                showToaster(error?.response?.data?.message || "Something Went wrong While submiting Form", 'Error', 'error')
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });

    }

   return (
        <Box>
            {/* <NormalContainerWithHeader headerText={"Assign Facility"}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 1,
                                    mb: 5
                                }}
                            >
                                {selectedFacility?.map((item, index) => (
                                    <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />
                                ))}
                            </Box>

                            <Grid2 container spacing={Grid_Gap}>

                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="facility_id"
                                        component={IdAutoCompleteField}
                                        options={facilityOption}
                                        label="Facility Option"
                                        isRequired={true}
                                        isLoading={isLoading}
                                        onValueChange={(newValue) => {
                                            setSelectedFacility((prev) => {
                                                const exists = prev?.find((item) => item?.id === newValue?.id);
                                                return exists ? prev : [...prev, newValue];
                                            });

                                        }}
                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={{ xs: 6, md: 4 }}>
                                    <Button variant='contained' type='submit' fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <CustomDivider /> */}

            <TermAndConditionTable id={user?.apartment_id} />


            <CustomDivider />
            <PayoutTable id={user?.apartment_id} />

            <CustomDivider />
            <MarketingTable id={user?.apartment_id} />
       

        </Box>
    )
}

export default ApartmentTCList